
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as OM from '@/Model';

@Options({
    components: {}
})
export default class MaterialCompositionSummary extends Vue {

    @Prop() row: OM.PercentageCompositionValues;
    @Prop({ default: false }) isReadOnly: boolean;

    // The Sangle's button must stay disabled until its grams are typed. The card does not need to
    // know what a Sangle is; the caller decides.
    @Prop({ default: false }) actionDisabled: boolean;

}
